<div class="yolo-detector-container">
  <h2>Detector YOLO - TensorFlow.js</h2>

  <div class="status-section">
    <h3>Estado del Modelo</h3>
    <div *ngIf="loading" class="loading">
      <p>Cargando...</p>
    </div>
    
    <div *ngIf="!loading && modelLoaded" class="success">
      <p>✓ Modelo cargado exitosamente</p>
    </div>

    <div *ngIf="error" class="error">
      <p>{{ error }}</p>
    </div>
  </div>

  <div *ngIf="modelLoaded" class="detection-section">
    <h3>Cargar Imagen para Detección</h3>
    
    <div class="upload-area">
      <input 
        type="file" 
        #fileInput
        (change)="onImageSelected($event)" 
        accept="image/*"
        style="display: none">
      
      <button 
        (click)="fileInput.click()" 
        class="upload-button"
        [disabled]="loading">
        Seleccionar Imagen
      </button>

      <button 
        (click)="sendMedialArchImage()" 
        class="upload-button"
        [disabled]="loading">
        Send medial arch image
      </button>
      <p>{{ medialArchResult }}</p>
    </div>

    <div *ngIf="selectedImage" class="results-section">
      <div *ngIf="detectionResults.length > 0" class="edit-mode-panel">
        <p class="edit-instructions">
          Arrastra los puntos para ajustar su posición. Una vez ajustados, pulsa en el siguiente botón:
        </p>
        <div class="edit-buttons">
          <button 
            class="update-button" 
            (click)="updateKeypoints()"
            [disabled]="anglesCorrected">
            Confirm Keypoints
          </button>
        </div>
        
        <div *ngIf="anglesCorrected" class="success-message">
          ✓ Keypoints corrected
        </div>
      </div>

      <div class="canvas-container">
        <canvas 
          #outputCanvas
          (mousedown)="onCanvasMouseDown($event)"
          (mousemove)="onCanvasMouseMove($event)"
          (mouseup)="onCanvasMouseUp()"
          (mouseleave)="onCanvasMouseUp()">
        </canvas>
      </div>
    </div>
  </div>
</div>
